import { UPLOAD_CRITERIAS } from '../enums'

export async function validateFileUploadCriteria(uploadProps: {
  imgW?: number
  imgH?: number
  imgSize?: number
  fileSize?: number
  thumbSize?: number
}): Promise<boolean> {
  const { imgW = 0, imgH = 0, imgSize = 0, fileSize = 0, thumbSize = 0 } = uploadProps

  const isWidthValid = imgW <= UPLOAD_CRITERIAS.MAX_W
  const isHeightValid = imgH <= UPLOAD_CRITERIAS.MAX_H
  const isImageSizeValid = imgSize <= UPLOAD_CRITERIAS.MAX_IMG_BYTE
  const isFileSizeValid = fileSize <= UPLOAD_CRITERIAS.MAX_DOC_BYTE
  const isThumbSizeValid = thumbSize <= UPLOAD_CRITERIAS.MAX_IMG_THUMB_BYTE

  return isWidthValid && isHeightValid && isImageSizeValid && isFileSizeValid && isThumbSizeValid
}
